module.exports = __webpack_public_path__ + "img/leg-left-front.20af2cc3.png";